<template>
  <div class="append-box" @touchmove="gtouchmove">
    <div class="container" ondragstart="return false;">
      <img src="@/assets/img/LOADING_bsplogo_01.png" class="img-bg abs-center-box" />
      <div class="circle-box abs-center-box">
        <img src="@/assets/img/LOADING_bsplogo_02.png" class="img-logo" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "loadingCircle",
  methods: {
    gtouchmove(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes play {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.append-box {
  z-index: 9999;
  .container {
    .img-bg {
      width: 0.9rem;
      height: 0.9rem;
    }
    .circle-box,
    .img-logo {
      height: 0.6rem;
      width: 0.6rem;
      display: block;
    }
    .img-logo {
      -webkit-animation: play 2s linear infinite;
      animation: play 2s linear infinite;
    }
  }
}
@media all and (orientation: portrait) {
  .append-box {
    .abs-center-box {
      transform: translate(-50%, -50%) rotate(90deg);
    }
  }
}
</style>